import React, { Component } from 'react';
import * as ReactDom from 'react-dom';
import { Form, ListGroup, Modal, Button } from 'react-bootstrap';
import axios from 'axios';
import Upload from './upload';
import ls from "local-storage";
import Webcam from "react-webcam";
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Facerecognition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            api_url: localStorage.getItem('api_url'),
            langKey: ls.get('LangValue'),
            modalWebCam: false,
            webcamPic: false,
            faceId: '',
            faceImage: '',
            permissionAlert: false,
            errors: {},
            hideCaptureBtn: false,
            uploadmodal: false,
        };
    }

    handleUploadOpenModal = () => {
        this.setState({ uploadmodal: true });
    }

    handleUploadCloseModal = () => {
        this.setState({ uploadmodal: false });
    }

    setRef = webcam => {
        this.webcam = webcam;
    };

    captureAgain = () => {
        this.setState({
            webcamPic : false,
            hideCaptureBtn: false
        })
    };

    capture = () => {
        var DetectRTC = require('detectrtc');
        let errors = {};
        DetectRTC.load(() =>{
            if(DetectRTC.hasMicrophone) {
                if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ 
                        video: true, 
                        audio: false 
                    }).then(stream => {
                        const imageSrc  = this.webcam.getScreenshot();
                        const element = React.createElement('img', { src:imageSrc });  
                        ReactDom.render(element, document.getElementById("capturedPhoto"));
                        var checkImage = new FormData();
                        checkImage.append('image', imageSrc); 
                        axios({ 
                            method: 'post', 
                            url: this.state.api_url+'checkFaceImage',
                            data: checkImage,
                            config: { headers: {'Content-Type': 'multipart/form-data' }}
                        }).then(res => {
                            if(res.data.status === false) {  
                                errors["captureImg"] = res.data.message; 
                                this.setState({ 
                                    loaderDisplay : false,
                                    webcamPic : false,
                                    errors: errors,
                                    errorMsg:'errorMsg',
                                    hideCaptureBtn: false,
                                });
                                setTimeout(() => {
                                    this.setState({
                                            errorMsg: 'errorMsghide'
                                    });
                                }, 2000);  
                            } else {
                                errors["captureImg"] = "";
                                this.setState({
                                    loaderDisplay : false,
                                    webcamPic : true,
                                    hideCaptureBtn: true,
                                    verifiedImageData: res.data,
                                    faceId:res.data.faceId,
                                    errors: errors,
                                    errorMsg:'errorMsg',
                                    faceImage:res.data.userVerificationImage,
                                });
                                localStorage.setItem('faceId', this.state.faceId);
                                localStorage.setItem('faceImage', this.state.faceImage);
                                setTimeout(() => {
                                    errors["captureImg_suc"] = "";
                                    this.setState({
                                        errors: errors,
                                        errorMsg: 'errorMsghide'
                                    });
                                }, 2000);  
                            }
                        })
                    }).catch(error => {
                        console.log('Error accessing media devices:', error);
                    });
                } else {
                    console.log('getUserMedia not supported in this browser.');
                }
            } else if(window.location.protocol !== 'https:'){
                this.setState({ 
                    loaderDisplay : false,
                    permissionAlert: true,
                });
            }
        });
    };

    saveFaceId = () => {
        this.props.handleClose();
        this.handleUploadOpenModal();
    };

    render() {
        const videoConstraints = {
            width: 1280,
            height: 720,
            facingMode: "user"
        };
        return (
            <div className="">
                <Modal className="premiumPopup vertically-center apd5 modal_div" show={this.props.showModal} centered>
                    <Modal.Header className="headerCap">
                        <Modal.Title className="takeimagetitle"><Trans i18nKey="Take your Image">Take your Image</Trans></Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="photoPopup takeyourimage"> 
                        <center>        
                            <div className="blueimgCap">                
                                <Webcam
                                audio={false}
                                forceScreenshotSourceSize="true"
                                ref={this.setRef}
                                mirrored
                                screenshotFormat="image/jpeg"
                                videoConstraints={videoConstraints}
                                style={{ display: this.state.webcamPic === false ? 'block' : 'none' }}
                                />
                                <div id="capturedPhoto" style={{ display: this.state.webcamPic === true ? 'block' : 'none' }} className='capturedPhotos'>   
                                </div>
                                <div className="webcamAlert" style={{ display: this.state.permissionAlert === true ? 'block' : 'none' }}><Trans i18nKey="Kindly allow your webcam Permission">Kindly allow your webcam Permission</Trans></div>
                            </div>
                            <div style={{"height" : "40px"}}></div>
                            <div className={this.state.errorMsg} style={{ paddingLeft: "25px" }}>
                                {this.state.errors.captureImg}
                            </div> 
                            <div className="successMsg" style={{ paddingLeft: "25px" }}>
                                {this.state.errors.captureImg_suc}   
                            </div>
                            <button onClick={this.captureAgain} className="retake-photo button_primary" style={{ display: this.state.hideCaptureBtn === true ? 'block' : 'none' }}><Trans i18nKey="Retake">Retake</Trans></button>
                            <button onClick={this.capture} className="cap-photo button_primary" style={{ display: this.state.hideCaptureBtn === false ? 'block' : 'none' }}><Trans i18nKey="Capture photo">Capture photo</Trans></button>
                            <button onClick={this.saveFaceId} className="cap-photo button_primary" style={{ display: this.state.hideCaptureBtn === true ? 'block' : 'none' }}><Trans i18nKey="Next">Next</Trans></button>
                        </center>
                    </Modal.Body>
                </Modal>
                <Upload
                    showModal={this.state.uploadmodal}
                    handleClose={this.handleUploadCloseModal}
                />
            </div>
        );
    }
}

export default Facerecognition;